export const supportedGeneralRecordKeys = ['name', 'description', 'url', 'location'] as const
